import { z } from "zod";

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  errors?: { field: string; message: string }[];
}

/** Schema para respuestas de éxito con data (OpenAPI/documentación). */
export const ApiResponseSuccessSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    success: z.literal(true),
    data: dataSchema,
  });

/** Schema para respuestas de error (OpenAPI/documentación). */
export const ApiResponseErrorSchema = z.object({
  success: z.literal(false),
  error: z.string().optional(),
  errors: z
    .array(z.object({ field: z.string(), message: z.string() }))
    .optional(),
});

/** Schema para respuestas de éxito sin data (logout, delete, etc.). */
export const ApiResponseSuccessEmptySchema = z.object({
  success: z.literal(true),
});
